import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, Alert, Form, Modal, Label, Input, Button, Table, UncontrolledTooltip } from "reactstrap";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PropTypes from 'prop-types';
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as ur from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";


import TreeMenu from 'react-simple-tree-menu';
import '../../../node_modules/react-simple-tree-menu/dist/main.css';

import FMap from 'pages/WQ/Maps/FMaps';
import SweetAlert from "react-bootstrap-sweetalert"




    const AssetRegister = () => {
      
      toastr.options = TOAST_OPTIONS;

      const [modal_umbrella, setmodal_umbrella] = useState(false);
      const [modal_cluster, setmodal_cluster] = useState(false);
      const [modal_area, setmodal_area] = useState(false);
      const [modal_scheme, setmodal_scheme] = useState(false);
      const [modal_facility, setmodal_facility] = useState(false);
      const [modal_facility_location, setmodal_facility_location] = useState(false);
      const [modal_cordinates, setmodal_cordinates] = useState(false);
      const [modal_equipment, setmodal_equipment] = useState(false);
      const [modal_type, setmodal_type] = useState(false);
      
      const [regions, setRegions] = useState([]);
      const [clusters, setClusters] = useState([]);
      const [areas, setAreas] = useState([]);
      const [schemes, setSchemes] = useState([]);
      const [facilities, setFacilities] = useState([]);
      const [fLocations, setFLocations] = useState([]);
      const [hasSelectedALocation, setHasSelectedALocation] = useState(false);
      const [assetTypes, setAssetTypes] = useState([]);
      const [facilityTypes, setFacilityTypes] = useState(['Borehole Station', 'Raw Water Pump Station','Water Pumping Station','Sump','Water Treatment Plant','Reservoir','Booster Station','Office','Feacal Sludge Treatment','Pipeline'])

      const [umbrellaName, setUmbrellaName] = useState('')
      const [umbrellaId, setUmbrellaId] = useState('')

      const [clusterName, setClusterName] = useState('')
      const [clusterId, setClusterId] = useState('')

      const [areaName, setAreaName] = useState('')
      const [areaId, setAreaId] = useState('')

      const [schemeName, setSchemeName] = useState('')
      const [schemeId, setSchemeId] = useState('')

      const [facilityName, setFacilityName] = useState('')
      const [facilityId, setFacilityId] = useState('')
      const [facilityType, setFacilityType] = useState('')
      const [facilityCordinates, setFacilityCordinates] = useState([])

      const [cordinates, setCordinates] = useState('')
    
      const [locationName, setLocationName] = useState('')
      const [locationId, setLocationId] = useState('')

      const [equipmentName, setEquipmentName] = useState('')
      const [equipmentId, setEquipmentId] = useState('')
      const [assetType, setAssetType] = useState('')
      const [yearInstalled, setYearInstalled] = useState('')
      const [make, setMake] = useState('')
      const [model, setModel] = useState('')
      const [capacity, setCapacity] = useState('')
      const [otherDetails, setOtherDetails] = useState('')
      const [assetCode, setAssetCode] = useState('')
      const [assetStatus, setAssetStatus] = useState('')
      const [isLoading, setIsLoading] = useState(false)

      const [isEdit, setIsEdit] = useState(false);
      const [treeData, setTreeData] = useState([])
      const [error_dlg, seterror_dlg] = useState(false)
      const [points, setPoints] = useState([])
      const [pipes, setPipes] = useState([])
      const [userId, setUserId] = useState('')
      
      const getData = () => {
        axios.get(ur.REGIONS, Config).then((r)=>{ setRegions(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.CLUSTERS, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.SCHEME, Config).then((r)=>{ setSchemes(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.FACILITIES, Config).then((r)=>{ setFacilities(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.FACILITYSTATION, Config).then((r)=>{ setFLocations(r.data); }).catch((e)=>{  console.log(e); });
        axios.get(ur.TYPES, Config).then((r)=>{ setAssetTypes(r.data);  }).catch((e)=>{  console.log(e); }); 
        axios.get(ur.TREE, Config).then((r)=>{ setTreeData(r.data); console.log(r.data) }).catch((e)=>{  console.log(e); });
        
        const mData = {filter:""}
        axios.post(ur.GEOCOORDINATES, JSON.stringify(mData), Config).then((r)=>{ setPoints(r.data); }).catch((e)=>{ console.log(e)})
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"))
            setUserId(obj.id)
          }
      }
      
      useEffect(() => {
       getData();
      },[]);
    
      const handleEditItem = (label, url) => {
        setIsLoading(true)
        if(url.includes('region')){
          tog_umbrella();
          let id = url.split("/")[1]
          axios.get(`${ur.REGIONS}/?${id}`, Config)
          .then((r)=>{  
            setIsLoading(false)
            setUmbrellaName(r.data[0].region)
            setUmbrellaId(r.data[0].id) 
            setIsEdit(true);
          }).catch((e)=>{ 
            setIsLoading(false) 
            console.log(e); 
          });
        }
        if(url.includes('cluster')){
          tog_cluster();
          let id = url.split("/")[1]
          axios.get(`${ur.CLUSTERS}/?${id}`, Config)
          .then((r)=>{  
            setIsLoading(false)
            setClusterName(r.data[0].cluster)
            setUmbrellaId(r.data[0].regionId) 
            setClusterId(r.data[0].id)
            setIsEdit(true);
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        if(url.includes('area')){
          tog_area();
          let id = url.split("/")[1]
          axios.get(`${ur.AREAS}/?${id}`, Config)
          .then((r)=>{
            setIsLoading(false)
            setUmbrellaId(r.data[0].region)
            setClusterId(r.data[0].cluster) 
            setAreaName(r.data[0].name)
            setAreaId(r.data[0].id)
            setIsEdit(true);
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        if(url.includes('scheme')){
          tog_scheme();
          let id = url.split("/")[1]
          axios.get(`${ur.SCHEME}/?${id}`, Config)
          .then((r)=>{
            setIsLoading(false)
            setUmbrellaId(r.data[0].region)
            setClusterId(r.data[0].cluster) 
            setAreaId(r.data[0].areaId) 
            setSchemeName(r.data[0].scheme)
            setSchemeId(r.data[0].id)
            setIsEdit(true);
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        if(url.includes('facility')){
          tog_facility();
          let facilityId = url.split("/")[1]
          axios.get(`${ur.FACILITIES}/?${facilityId}`, Config)
          .then((r)=>{ 
            setIsLoading(false)
            setUmbrellaId(r.data[0].region)
            setClusterId(r.data[0].cluster) 
            setAreaId(r.data[0].areaId)
            setSchemeId(r.data[0].schemeId)
            setFacilityId(r.data[0].id)
            setFacilityName(r.data[0].facility)
            setFacilityType(r.data[0].facilityType)
            axios.post(ur.GEOCOORDINATES, JSON.stringify({filter: r.data[0].id}), Config).then((rr)=>{ 
              if(rr.data.length > 0){
                //console.log(rr.data[0].geometry.coordinates)
                setPoints(rr.data); 
                setCordinates(rr.data[0].geometry.coordinates[1]+', '+rr.data[0].geometry.coordinates[0])
              }
            }).catch((ee)=>{ console.log(ee)})
            setIsEdit(true);
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
            
        }
        if(url.includes('location')){
          tog_facility_location();
          let locationId = url.split("/")[1]
          axios.get(`${ur.FACILITYSTATION}/?${locationId}`, Config)
          .then((r)=>{ 
            setIsLoading(false)
            setUmbrellaId(r.data[0].region)
            setClusterId(r.data[0].cluster) 
            setAreaId(r.data[0].area)
            setSchemeId(r.data[0].scheme)
            setFacilityId(r.data[0].facilityId)
            setLocationId(r.data[0].id)
            setLocationName(r.data[0].location)
            setIsEdit(true);
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          }); 
        }
        if(url.includes('equipment')){
          tog_equipment();
          let equipmentId = url.split("/")[1]
          axios.get(`${ur.EQUIPMENT}/?${equipmentId}`, Config)
          .then((r)=>{ 
            setIsLoading(false)
            setIsEdit(true);
            setUmbrellaId(r.data[0].region)
            setClusterId(r.data[0].cluster) 
            setAreaId(r.data[0].area)
            setSchemeId(r.data[0].scheme)
            setFacilityId(r.data[0].facilityId)
            setLocationId(r.data[0].locationId)
            setEquipmentId(r.data[0].id)
            setEquipmentName(r.data[0].name)
            setAssetType(r.data[0].category)
            setYearInstalled(r.data[0].year)
            setMake(r.data[0].make)
            setModel(r.data[0].model)
            setCapacity(r.data[0].capacity)
            setOtherDetails(r.data[0].other)
            setAssetStatus(r.data[0].status)
            setAssetCode(r.data[0].code)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
      }


      const removeBodyCss = () => {
        document.body.classList.add("no_padding");
      }
      const tog_umbrella = () => {
        setmodal_umbrella(!modal_umbrella);
        removeBodyCss();
      }
      const tog_cluster = () => {
        setmodal_cluster(!modal_cluster);
        removeBodyCss();
      }
      const tog_area = () => {
        setmodal_area(!modal_area);
        removeBodyCss();
      }
      const tog_scheme = () => {
        setmodal_scheme(!modal_scheme);
        removeBodyCss();
      }
      const tog_facility = () => {
        setmodal_facility(!modal_facility);
        removeBodyCss();
      }
      const tog_facility_location = () => {
        setmodal_facility_location(!modal_facility_location);
        removeBodyCss();
      }
      const tog_equipment = () => {
        setmodal_equipment(!modal_equipment);
        removeBodyCss();
      }
      const tog_type = () => {
        setmodal_type(!modal_type);
        removeBodyCss();
      }
      const handleGetClusters = (u) =>{
        setIsLoading(true)
        axios.get(`${ur.CLUSTERS}?region?${u}`, Config).then((r)=>{
          setClusters(r.data)
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })  
      }
      const handleGetAreas = (c) =>{
        setIsLoading(true)
        axios.get(`${ur.AREAS}?cluster?${c}`, Config).then((r)=>{
          setAreas(r.data)
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })
      }
      const handleGetSchemes = (a) =>{
        setIsLoading(true)
        axios.get(`${ur.SCHEME}?area?${a}`, Config).then((r)=>{
          setSchemes(r.data)   
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })
      }
      const handleSaveUmbrella = () =>{
        if(umbrellaName.trim().length < 3){
          toastr.error('Enter Region name')
        }else{
          let data = {}
          if(isEdit){
            data = {
              id: umbrellaId,
              name: umbrellaName,
              userId: userId,
              action: 'edit'
            }
          }else{
            data = {
              name: umbrellaName,
              userId: userId,
              action: 'add'
            }
          } 
          setIsLoading(true)
          axios.post(ur.REGIONS, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
              toastr.success(r.data.message)
              tog_umbrella()
              setUmbrellaName('')
            }else{
              toastr.error(r.data.message)
            }
            getData()
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e)
            setIsLoading(false)
          })  
      }  
    } 
    const handleSaveCluster = () =>{
      if(umbrellaId == ""){
        toastr.error('Select Region name')
      }else if(clusterName.trim().length < 3){
        toastr.error('Enter cluster name')
      }else{
        let data = {}
        if(isEdit){
          data = {
            id: clusterId,
            region: umbrellaId,
            name: clusterName,
            userId: userId,
            action: 'edit'
          }
        }else{
          data = {
            region: umbrellaId,
            name: clusterName,
            userId: userId,
            action: 'add'
          }
        } 
        setIsLoading(true)
        axios.post(ur.CLUSTERS, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == 1){
            toastr.success(r.data.message)
            tog_cluster()
            setClusterName('')
            setUmbrellaId('')
          }else{
            toastr.error(r.data.message)
          }
          getData()
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })  
     }  
    }   
      const handleSaveArea = (e)=>{
        if(umbrellaId == ""){
          toastr.error('Select Region')
        }else if(clusterId == ""){
          toastr.error('Select cluster')
        }else if(areaName.trim().length < 2){
          toastr.error('Enter area name');
        }else{
          let data = {}
          if(isEdit){
            data = {
              id: areaId,
              clusterId: clusterId,
              name: areaName,
              userId: userId,
              action: 'edit'
            };
          }else{
            data = {
              clusterId: clusterId,
              name: areaName,
              userId: userId,
              action: 'add'
            };
          }
          setIsLoading(true)
          axios.post(ur.AREAS, JSON.stringify(data), Config)
          .then((r)=>{
            if(r.data.status == '0'){
              toastr.error(r.data.message); 
            }else{
              toastr.success(r.data.message); 
              setUmbrellaId('')
              setClusterId('')
              setAreaName('')
              getData();
              tog_area();
            }
            setIsLoading(false)
          })
          .catch((e)=>{
            console.log(e);
            setIsLoading(false)
          });
        }
      }

      const handleAddType = (e)=>{
        setIsLoading(true)
        const txtAssetType = document.getElementsByClassName("assetType")[0].value;
        const data = { "type": txtAssetType }
        axios.post(ur.TYPES, JSON.stringify(data), Config)
        .then((r)=>{
          if(r.data.status == '0'){
            toastr.error(r.data.message); 
          }else{
            toastr.success(r.data.message); 
            getData();
            tog_facility();
          }
          setIsLoading(false)
        })
        .catch((e)=>{
          console.log(e);
          setIsLoading(false)
        });
      }

      const handleAddFacility = () =>{
        const pattern = /^-?\d{1,3}\.\d{1,6},\s?-?\d{1,3}\.\d{1,6}$/;
        if(areaId == ""){
          toastr.error('Select area')
        } else if(!pattern.test(cordinates)){
          toastr.error('Invalid coordinates')
        }else{
          let data = {}
          if (isEdit) {
            data = {
              "method":"edit",
              "id"    :facilityId,
              "schemeId": schemeId,
              "name"  : facilityName,
              "type"  : facilityType,
              "userId": userId,
              "cordinates"  : cordinates
            }
          }else{
            data = {
              "method"  :"add",
              "schemeId"  : schemeId,
              "name"    : facilityName,
              "type"    : facilityType,
              "userId": userId,
              "cordinates"  : cordinates
            }
          }
          setIsLoading(true)
          axios.post(ur.FACILITIES, JSON.stringify(data), Config)
            .then((r)=>{
              if(r.data.status == '0'){
                toastr.error(r.data.message); 
              }else{
                toastr.success(r.data.message); 
                getData();
                tog_facility();
                setUmbrellaId('')
                setClusterId('')
                setAreaId('')
                setSchemeId('')
                setFacilityName('')
                setFacilityType('')
              }
              setIsLoading(false)
            })
            .catch((e)=>{
              console.log(e);
              setIsLoading(false)
            });
        
          
        }
      }
      const handleDeleteEquipment = () =>{
        const data = { name : "equipment", id: equipmentId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_equipment();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }
      const handleDeleteLocation = () =>{
        const data = { name : "location", id: locationId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_facility_location();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }
      const handleDeleteFacility = () =>{
        const data = { name : "facility", id: facilityId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_facility();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }
      const handleDeleteScheme = () =>{
        const data = { name : "scheme", id: schemeId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_scheme();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }
      const handleDeleteArea = () =>{
        const data = { name : "area", id: areaId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_area();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }
      const handleDeleteCluster = () =>{
        const data = { name : "cluster", id: clusterId, userId: userId }
        setIsLoading(true)
        axios.post(ur.MMDELETE, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == "1"){
            toastr.warning(r.data.message);
            getData();
            tog_cluster();
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false);
        }).catch((e)=>{
          console.log(e);
          setIsLoading(false)
        })
      }

      const handleGetSchemesInArea = (a) => {
        setIsLoading(true)
        setSchemes([])
        axios.get(ur.SCHEME+"?area?"+a, Config).then((r)=>{ 
          setSchemes(r.data); 
          setIsLoading(false)
        }).catch((e)=>{  
          console.log(e);
          setIsLoading(false)
        });
      }
      const handleGetFacilitiesInScheme = (s) =>{
        setFacilities([])  
        setIsLoading(true)
        axios.get(ur.FACILITIES+"?scheme?"+s, Config).then((r)=>{ 
          setFacilities(r.data);
          setIsLoading(false)
        }).catch((e)=>{  
          console.log(e); 
          setIsLoading(false)
        });
      }

      const handleAddFacilityLocation = () => {
   
        let data = {}
        if(isEdit){
          data = {
            "method"  	:"edit",
            "id"        : locationId,
            "facilityId": facilityId,
            "userId"    : userId,
            "location"  : locationName
          }
        }else{
          data = {
            "method"    :"add",
            "facilityId": facilityId,
            "userId"    : userId,
            "location"  : locationName
          }
        }
        setIsLoading(true)
        axios.post(ur.FACILITYSTATION, JSON.stringify(data), Config)
        .then((r)=>{
          if(r.data.status == '0'){
            toastr.error(r.data.message); 
          }else{
            toastr.success(r.data.message); 
            tog_facility_location();
            setUmbrellaId('')
            setClusterId('')
            setAreaId('')
            setSchemeId('')
            setFacilityId('')
            setLocationName('')
            getData();
          }
          setIsLoading(false)
        })
        .catch((e)=>{
          console.log(e);
          setIsLoading(false)
        });
        
      }
      const handleSaveScheme = () =>{
        let data = {}
        if(isEdit){
          data = {
            "method"  	:"edit",
            "id"        : schemeId,
            "areaId"    : areaId,
            "userId"    : userId,
            "name"      : schemeName
          }
        }else{
          data = {
            "method"    :"add",
            "areaId"    : areaId,
            "userId"    : userId,
            "name"      : schemeName
          }
        }
        setIsLoading(true)
        axios.post(ur.SCHEME, JSON.stringify(data), Config)
        .then((r)=>{
          console.log(r)
          if(r.data.status == '0'){
            toastr.error(r.data.message); 
          }else{
            toastr.success(r.data.message); 
            tog_scheme();
            setUmbrellaId('')
            setClusterId('')
            setAreaId('')
            setSchemeName('')
            setSchemeId('')
            getData();
          }
          setIsLoading(false)
        })
        .catch((e)=>{
          console.log(e);
          setIsLoading(false)
        });
      }
      const handleGetLocationsInFacility = (f) => {
        setIsLoading(true)
        axios.get(ur.FACILITYSTATION+"?facility?"+f, Config)
        .then((r)=>{ 
           if(r.data.length < 1){
            seterror_dlg(true); 
          }else{
               setFLocations(r.data);
               seterror_dlg(false); 
          }
          setIsLoading(false)
         }).catch((e)=>{  
          console.log(e); 
          setIsLoading(false)
        });
      }

      const handleLocationChange = (locationClass) => {
        if(document.getElementsByClassName(locationClass)[0].value == "0"){
          setHasSelectedALocation(false);
        }else{
          setHasSelectedALocation(true);
        }
      }

      const handleSaveEquipment = () => {
        
        let data = {}
        if(isEdit){
          data = {
            "method"    : "edit",
            "id"        : equipmentId,
            "locationId": locationId,
            "name"      : equipmentName,
            "category"  : assetType,
            "year"      : yearInstalled,
            "make"      : make,
            "model"     : model,
            "capacity"  : capacity,
            "other"     : otherDetails,
            "status"    : assetStatus,
            "userId"    : userId,
            "code"      : assetCode
          }
        }else{
          data = {
            "method"    : "add",
            "locationId": locationId,
            "name"      : equipmentName,
            "category"  : assetType,
            "year"      : yearInstalled,
            "make"      : make,
            "model"     : model,
            "capacity"  : capacity,
            "other"     : otherDetails,
            "status"    : assetStatus,
            "userId"    : userId,
            "code"      : assetCode
          }
        }
        console.log(data)
        setIsLoading(true)
        axios.post(ur.EQUIPMENT, JSON.stringify(data), Config)
        .then((r)=>{
          if(r.data.status == '0'){
            toastr.error(r.data.message); 
          }else{
            toastr.success(r.data.message); 
            tog_equipment();
            getData();
            setUmbrellaId('')
            setClusterId('')
            setAreaId('')
            setSchemeId('')
            setFacilityId('')
            setLocationId('')
            setEquipmentName('')
            setAssetType('')
            setYearInstalled('')
            setMake('')
            setModel('')
            setCapacity('')
            setOtherDetails('')
            setAssetStatus('')
            setAssetCode('')
          }
          setIsLoading(false)
        })
        .catch((e)=>{
          console.log(e);
          setIsLoading(false)
        });
      }
      const clearData = () =>{
            setUmbrellaId('')
            setUmbrellaName('')
            setClusterId('')
            setClusterName('')
            setAreaId('')
            setAreaName('')
            setSchemeId('')
            setSchemeName('')
            setFacilityId('')
            setFacilityName('')
            setFacilityType('')
            setFacilityCordinates([])
            setLocationId('')
            setLocationName('')
            setEquipmentId('')
            setEquipmentName('')
            setAssetType('')
            setYearInstalled('')
            setMake('')
            setModel('')
            setCapacity('')
            setOtherDetails('')
            setAssetStatus('')
            setAssetCode('')
      }
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Asset Register | {ur.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                    {error_dlg ? (
                                <SweetAlert
                                  error
                                  title = "No Location"
                                  onConfirm={() => {
                                    seterror_dlg(false)
                                    tog_facility_location()
                                  }}
                                >
                                  Selected facility has no registered location. Press OK to add location
                                </SweetAlert>
                              ) : null}
                        
                        
                       
                                  <Modal isOpen={modal_umbrella} toggle={() => { tog_umbrella() }} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Edit`:`Add`} Region</h5>
                                    <button onClick={() => { setmodal_umbrella(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Authority name</label>
                                            <Input type="text" className="form-control"  value={umbrellaName} onChange={(e)=>setUmbrellaName(e.target.value)} />
                                        </div>
                                    </Col>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<button onClick={() => { setClusterName(''); tog_cluster(); setIsEdit(false); tog_umbrella()  }} className="btn btn-primary" data-dismiss="modal">Add acluster to this region</button>)}
                                    <button className="btn btn-success" onClick={() => { handleSaveUmbrella() }}>Save region details...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_cluster} toggle={() => { tog_cluster() }} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Edit`:`Add`} Cluster</h5>
                                    <button onClick={() => { setmodal_cluster(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>setUmbrellaId(e.target.value)}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Cluster name</label>
                                            <Input type="text" className="form-control"  value={clusterName} onChange={(e)=>setClusterName(e.target.value)} />
                                        </div>
                                    </Col>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<><button onClick={() => { setAreaName(''); tog_area(); setIsEdit(false); tog_cluster()  }} className="btn btn-primary" data-dismiss="modal">Add area to this cluster</button><button onClick={handleDeleteCluster} className="btn btn-warning" data-dismiss="modal">Delete cluster details</button></>)}
                                    <button className="btn btn-success" onClick={() => { handleSaveCluster() }}>Save cluster details...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_area} toggle={() => { tog_area() }} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Edit`:`Add`} Area</h5>
                                    <button onClick={() => { setmodal_area(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   {!isEdit && (<>
                                   <Col md={12}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value), handleGetClusters(e.target.value)}}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select"  value={clusterId} onChange={(e)=>{setClusterId(e.target.value)}}>
                                            <option value=""></option>
                                            {clusters.map((r,k)=>(<option key={k} value={r.id}>{r.cluster}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    </>)}
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Area name</label>
                                            <Input type="text" className="form-control"  value={areaName} onChange={(e)=>setAreaName(e.target.value)} />
                                        </div>
                                    </Col>
                                    
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<><button onClick={() => { setSchemeName(''); tog_scheme(); setIsEdit(false); tog_area()  }} className="btn btn-primary" data-dismiss="modal">Add scheme to this area</button><button onClick={handleDeleteArea} className="btn btn-warning" data-dismiss="modal">Delete Area details</button></>)}
                                    
                                    <button className="btn btn-success" onClick={() => { handleSaveArea() }}>Save area details...</button>
                                    </>)}
                                  </div>
                                </Modal>


                                <Modal isOpen={modal_type} toggle={() => { tog_type() }} centered>
                                      <div className="table-responsive">
                                    <Table  className="table table mb-0">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Asset Type</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(assetTypes || []).map((t,k)=>(
                                          <tr key={k}>
                                          <th scope="row">{k+1}</th>
                                          <td>{t.type}</td>
                                        </tr>
                                        ))}
                                       
                                        
                                      </tbody>
                                    </Table>
                                  </div>
                                  <div className="modal-body">
                                    <Form>
                                      <Col sm={12}>
                                        <Input
                                          type="text"
                                          className="form-control assetType"
                                          id="horizontal-firstname-Input"
                                          placeholder="Add Asset Type"
                                        />
                                      </Col>
                                    </Form>
                                  
                                  </div>
                                 
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_type()
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick={() => { handleAddType() }}
                                    >
                                      Save...
                                    </button>
                                    </>)}
                                  
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_scheme} toggle={() => { tog_scheme(); }} centered >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit ': 'Add '}Scheme</h5>
                                    <button onClick={() => { setmodal_scheme(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  
                                   <Col md={12}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value), handleGetClusters(e.target.value)}}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select"  value={clusterId} onChange={(e)=>{setClusterId(e.target.value); handleGetAreas(e.target.value)}}>
                                            <option value=""></option>
                                            {clusters.map((r,k)=>(<option key={k} value={r.id}>{r.cluster}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select"  value={areaId} onChange={(e)=>{setAreaId(e.target.value);}}>
                                            <option value=""></option>
                                            {areas.map((r,k)=>(<option key={k} value={r.id}>{r.name}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Scheme name</label>
                                            <Input type="text" className="form-control" value={schemeName} onChange={(e)=>setSchemeName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<><button onClick={() => { setFacilityName(''); setFacilityType(''); tog_facility(); setIsEdit(false); tog_scheme()  }} className="btn btn-primary" data-dismiss="modal">Add facility to this scheme</button><button onClick={handleDeleteScheme} className="btn btn-warning" data-dismiss="modal">Delete Scheme details</button></>)}
                                    <button className="btn btn-success" onClick={()=>{ handleSaveScheme() }}>Save scheme details...</button>
                                    </>)}
                                  </div>
                                </Modal>



                                <Modal isOpen={modal_facility} toggle={() => { tog_facility(); }} centered >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Facility/Pipeline ': 'Add Facility/Pipeline' }</h5>
                                    <button onClick={() => { setmodal_facility(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Col md={12}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value); handleGetClusters(e.target.value)}}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select"  value={clusterId} onChange={(e)=>{setClusterId(e.target.value); handleGetAreas(e.target.value)}}>
                                            <option value=""></option>
                                            {clusters.map((r,k)=>(<option key={k} value={r.id}>{r.cluster}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select"  value={areaId} onChange={(e)=>{setAreaId(e.target.value); handleGetSchemes(e.target.value);}}>
                                            <option value=""></option>
                                            {areas.map((r,k)=>(<option key={k} value={r.id}>{r.name}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Scheme</label>
                                            <select className="form-select"  value={schemeId} onChange={(e)=>{setSchemeId(e.target.value);}} >
                                            <option value=""></option>
                                            {schemes.map((r,k)=>(<option key={k} value={r.id}>{r.scheme}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Facility name /Pipeline</label>
                                            <Input type="text" className="form-control" value={facilityName} onChange={(e)=>setFacilityName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Facility type</label>
                                            <select className="form-select"  value={facilityType} onChange={(e)=>{setFacilityType(e.target.value);}}>
                                            <option value=""></option>
                                            { facilityTypes && facilityTypes.map((t,k)=>(<option key={k} value={t}>{t}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Coordinates</label>
                                            <Input type="text" className="form-control" value={cordinates} onChange={(e)=>setCordinates(e.target.value)}/>
                                        </div>
                                    </Col>
                   
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && 
                                    (<><button onClick={() => { setLocationName('');  tog_facility_location(); setIsEdit(false); tog_facility()  }} className="btn btn-primary" data-dismiss="modal">Add location to facility</button><button className="btn btn-warning" onClick={()=>{ handleDeleteFacility() }}>Delete facility details...</button></>)}
                                    
                                    

                                    <button className="btn btn-success" onClick={()=>{ handleAddFacility() }}>Save facility details...</button>
                                    </>)}
                                  </div>
                                </Modal>


                                <Modal isOpen={modal_facility_location} toggle={() => { tog_facility_location(); }} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Location Inside Facility ': 'Add Location Inside Facility' }</h5>
                                    <button onClick={() => { setmodal_facility_location(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  
                                   <Col md={12}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value), handleGetClusters(e.target.value)}}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select"  value={clusterId} onChange={(e)=>{setClusterId(e.target.value); handleGetAreas(e.target.value)}}>
                                            <option value=""></option>
                                            {clusters.map((r,k)=>(<option key={k} value={r.id}>{r.cluster}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select"  value={areaId} onChange={(e)=>{setAreaId(e.target.value); handleGetSchemesInArea(e.target.value)}}>
                                            <option value=""></option>
                                            {areas.map((r,k)=>(<option key={k} value={r.id}>{r.name}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Scheme</label>
                                            <select className="form-select"  value={schemeId} onChange={(e)=>{setSchemeId(e.target.value); handleGetFacilitiesInScheme(e.target.value)}} >
                                            <option value=""></option>
                                            {schemes.map((r,k)=>(<option key={k} value={r.id}>{r.scheme}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Facility</label>
                                            <select className="form-select"  value={facilityId} onChange={(e)=>{setFacilityId(e.target.value);}}>
                                            <option value=""></option>
                                            {facilities.map((f,k)=>(<option key={k} value={f.id}>{f.facility}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Location</label>
                                            <Input type="text" className="form-control" value={locationName} onChange={(e)=>setLocationName(e.target.value)}/>
                                        </div>
                                    </Col>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    {isEdit && (<><button onClick={() => { setEquipmentName(''); setAssetType(''); setYearInstalled(''); setModel(''); setMake(''); setCapacity(''); setOtherDetails(''); setAssetCode(''); setAssetStatus(''); tog_equipment(); setIsEdit(false); tog_facility_location()  }} className="btn btn-primary" data-dismiss="modal">Add equipment to this location</button><button onClick={() => { handleDeleteLocation()  }} className="btn btn-warning" data-dismiss="modal">Delete Location details</button></>)}
                                    <button className="btn btn-success" onClick={handleAddFacilityLocation}>Save location details...</button>
                                    </>)}
                                  </div>
                                 
                                </Modal>


                                <Modal isOpen={modal_equipment} toggle={() => { tog_equipment();  }}  centered size='xl' >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit Equipment ': 'Add Equipment' }</h5>
                                    <button onClick={() => { setmodal_equipment(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  
                                  <Row>
                                   <Col md={4}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select"  value={umbrellaId} onChange={(e)=>{setUmbrellaId(e.target.value), handleGetClusters(e.target.value)}}>
                                            <option value=""></option>
                                            {regions.map((r,k)=>(<option key={k} value={r.id}>{r.region}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select"  value={clusterId} onChange={(e)=>{setClusterId(e.target.value); handleGetAreas(e.target.value)}}>
                                            <option value=""></option>
                                            {clusters.map((r,k)=>(<option key={k} value={r.id}>{r.cluster}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select"  value={areaId} onChange={(e)=>{setAreaId(e.target.value); handleGetSchemesInArea(e.target.value)}}>
                                            <option value=""></option>
                                            {areas.map((r,k)=>(<option key={k} value={r.id}>{r.name}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Scheme</label>
                                            <select className="form-select"  value={schemeId} onChange={(e)=>{setSchemeId(e.target.value); handleGetFacilitiesInScheme(e.target.value)}} >
                                            <option value=""></option>
                                            {schemes.map((r,k)=>(<option key={k} value={r.id}>{r.scheme}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Facility</label>
                                            <select className="form-select"  value={facilityId} onChange={(e)=>{setFacilityId(e.target.value); handleGetLocationsInFacility(e.target.value)}} >
                                            <option value=""></option>
                                            {facilities.map((f,k)=>(<option key={k} value={f.id}>{f.facility}</option>))}
                                            </select>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Location</label>
                                            <select className="form-select"  value={locationId} onChange={(e)=>{setLocationId(e.target.value);}} >
                                            <option value=""></option>
                                              {fLocations.map((l,k)=>(
                                                <option key={k} value={l.id}>{l.location}</option>
                                              ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Equipment name</label>
                                            <Input type="text" className="form-control" value={equipmentName} onChange={(e)=>setEquipmentName(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Equipment type</label>
                                            <select className="form-select" value={assetType} onChange={(e)=>setAssetType(e.target.value)}>
                                              <option value=""></option>
                                              
                                                {assetTypes.map((t,k)=>(
                                                  <option key={k} value={t.id}>{t.type}</option>
                                                )
                                              )}
                                        </select>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Year Installed</label>
                                            <Input type="number" className="form-control" value={yearInstalled} onChange={(e)=>setYearInstalled(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Make</label>
                                            <Input type="text" className="form-control" value={make} onChange={(e)=>setMake(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Model</label>
                                            <Input type="text" className="form-control" value={model} onChange={(e)=>setModel(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Capacity</label>
                                            <Input type="text" className="form-control" value={capacity} onChange={(e)=>setCapacity(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                      <div className="mb-3">
                                            <label>Other details</label>
                                            <textarea className="form-control" value={otherDetails} onChange={(e)=>setOtherDetails(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                      <div className="mb-3">
                                            <label>Asset code</label>
                                            <Input type="text" className="form-control" value={assetCode} onChange={(e)=>setAssetCode(e.target.value)}/>
                                        </div>
                                    </Col>
                                    <Col md={8}>
                                      <div className="mb-3">
                                            <label>Asset status</label>
                                            <select className="form-control" value={assetStatus} onChange={(e)=>setAssetStatus(e.target.value)}>
                                            <option value=""></option>
                                            <option value="Operational">Operational</option>
                                            <option value="Faulty">Faulty</option>
                                            <option value="Decommissioned">Decommissioned</option>
                                          </select>
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                  {isLoading?<Alert>Please wait...</Alert>:(<>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        tog_equipment();
                                      }}
                                      className="btn btn-danger "
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    {isEdit && <button
                                      type="button"
                                      className="btn btn-warning"
                                      onClick={handleDeleteEquipment}
                                    >
                                      Delete Equipment...
                                    </button>}
                                    <button
                                      type="button"
                                      className="btn btn-success "
                                      onClick={handleSaveEquipment}
                                    >
                                      Save equipment details...
                                    </button>
                                    </>)}
                                  </div>
                                </Modal>



                 
                        <Row>

                        <Col lg={7}>
                          <Card>
                          
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">ASSET HIERACHY</h5>
                          
                            <CardBody>                            
                              <TreeMenu data={treeData} initialOpenNodes={['first-level-node-7', 'second-level-node-8', 'third-level-node-9']}   onClickItem={({ key, label, ...props }) => {  handleEditItem(label, props.url)   }} />  
                            </CardBody>
                          </Card>
                        </Col>
                        <Col lg={5}>
                          <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">ASSET MAP</h5>
                                                        
                              <FMap points={points} pipes={pipes}/>
                         
                          </Card>
                        </Col>
                      </Row> 
                        
                           

                    </Container>
                </div>
            </>
        );
    }
    AssetRegister.propTypes = {
      url: PropTypes.any
    };
export default AssetRegister;